<template>
  <a-drawer placement="right" :closable="false" :mask-closable="false" :visible="visible"
            width="1200" :body-style="{'padding':'12px','box-sizing':'border-box','height':'92%','overflow':'auto'}">
    <div slot="title" class="gpws-drawer-title-span">
      <div class="gpws-drawer-close" @click="()=>onDrawerClose()"><a-icon type="close" style="margin-right: 3px" />关闭</div>
      <span class="gpws-drawer-title">患者档案</span>
      <span></span>
    </div>
    <a-table size="middle" class="gpws-visit-table" :columns="grid.columns" :loading="grid.loading" rowKey="id" :dataSource="grid.data" :pagination="grid.pagination" @change="gridChangeAction" @expand="loadMedical">
      <span slot="index" slot-scope="text, record, index">
        {{ (((grid.pagination.current - 1) * grid.pagination.pageSize) + index + 1) }}
      </span>
      <span slot="operate" slot-scope="text, record, index">
        <a-button type="link" v-if="((record.recipes||[]).length > 0 && grid.source === 'EXPERT')" @click="recipeAction(record.id)">重用处方</a-button>
      </span>
      <div slot="expandedRowRender" slot-scope="record">
        <a-card v-if="((medicals||[]).filter(m => m.id == record.id).length > 0 && (medicals||[]).filter(m => m.id == record.id)[0].existed)" size="small" :bordered="false"
            :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}"
            :body-style="{'padding':'0px'}">
            <span slot="title" class="gpws-archive-model-title">
              <img src="src/assets/img/split.png" style="margin-right: 9px;user-select: none;"/>门诊病历
            </span>
          <a-row>
            <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
              <a-form-item label="姓名" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].name }}
              </a-form-item>
            </a-col>
            <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
              <a-form-item label="年龄" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].age }}
              </a-form-item>
            </a-col>
            <a-col :xxl="10" :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
              <a-form-item label="身份证号" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].idcard }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
              <a-form-item label="性别" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].sexName }}
              </a-form-item>
            </a-col>
            <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
              <a-form-item label="孕否" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].gestate?'孕':'否' }}
              </a-form-item>
            </a-col>
            <a-col :xxl="10" :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
              <a-form-item label="电话号码" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].phone }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
              <a-form-item label="婚否" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].marriageName }}
              </a-form-item>
            </a-col>
            <a-col :xxl="17" :xl="17" :lg="17" :md="24" :sm="24" :xs="24">
              <a-form-item label="详细地址" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }" :wrapper-col="{sm: 24, md: 12, lg: 19, xl: 19, xxl: 19 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].address }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
              <a-form-item label="就诊机构" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].organ }}
              </a-form-item>
            </a-col>
            <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
              <a-form-item label="就诊科室" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].department }}
              </a-form-item>
            </a-col>
            <a-col :xxl="10" :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
              <a-form-item label="接诊医生" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].doctor }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="(undefined != record.expert && null != record.expert && '' != record.expert)">
            <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
              <a-form-item label="辅诊机构" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].expertOrgan }}
              </a-form-item>
            </a-col>
            <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
              <a-form-item label="辅诊科室" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].expertDepart }}
              </a-form-item>
            </a-col>
            <a-col :xxl="10" :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
              <a-form-item label="辅诊专家" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].expert }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
              <a-form-item label="就诊类型" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].visitType }}
              </a-form-item>
            </a-col>
            <a-col :xxl="17" :xl="17" :lg="17" :md="24" :sm="24" :xs="24">
              <a-form-item :label="(((medicals || []).filter(m => m.id == record.id)[0].status=='NEW' || (medicals || []).filter(m => m.id == record.id)[0].status=='TREATING')?'初步诊断':'疾病诊断')" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }" :wrapper-col="{sm: 24, md: 12, lg: 19, xl: 19, xxl: 19 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].diagnostic }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="((medicals||[]).filter(m => m.id == record.id)[0].medical.complaint||'') != ''">
            <a-col>
              <a-form-item label="主诉" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].medical.complaint }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="((medicals||[]).filter(m => m.id == record.id)[0].medical.currHistory||'') != ''">
            <a-col>
              <a-form-item label="现病史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].medical.currHistory }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="((medicals||[]).filter(m => m.id == record.id)[0].medical.allergyHistory||'') != ''">
            <a-col>
              <a-form-item label="过敏史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].medical.allergyHistory }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="((medicals||[]).filter(m => m.id == record.id)[0].medical.auxiliary||'') != ''">
            <a-col>
              <a-form-item label="辅助检查" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].medical.auxiliary }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="((medicals||[]).filter(m => m.id == record.id)[0].medical.laboratory||'') != ''">
            <a-col>
              <a-form-item label="临床检验" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].medical.laboratory }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col>
              <a-form-item :colon="false" label="体格检查" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                <a-row>
                  <a-col v-if="(medicals || []).filter(m => m.id == record.id)[0].medical.physical.height" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                    <a-form-item label="身高" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }"
                                 :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                      {{ (medicals || []).filter(m => m.id == record.id)[0].medical.physical.height }} CM
                    </a-form-item>
                  </a-col>
                  <a-col v-if="(medicals || []).filter(m => m.id == record.id)[0].medical.physical.weight" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                    <a-form-item label="体重" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }"
                                 :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                      {{ (medicals || []).filter(m => m.id == record.id)[0].medical.physical.weight }} KG
                    </a-form-item>
                  </a-col>
                  <a-col v-if="(medicals || []).filter(m => m.id == record.id)[0].medical.physical.pulse" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                    <a-form-item label="脉搏" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }"
                                 :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                      {{ (medicals || []).filter(m => m.id == record.id)[0].medical.physical.pulse }} 次/分钟
                    </a-form-item>
                  </a-col>
                  <a-col v-if="(medicals || []).filter(m => m.id == record.id)[0].medical.physical.hr" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                    <a-form-item label="心率" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }"
                                 :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                      {{ (medicals || []).filter(m => m.id == record.id)[0].medical.physical.hr }} 次/分钟
                    </a-form-item>
                  </a-col>
                  <a-col v-if="(medicals || []).filter(m => m.id == record.id)[0].medical.physical.temperature" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                    <a-form-item label="体温" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }"
                                 :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                      {{ (medicals || []).filter(m => m.id == record.id)[0].medical.physical.temperature }} ℃
                    </a-form-item>
                  </a-col>
                  <a-col v-if="(medicals || []).filter(m => m.id == record.id)[0].medical.physical.sbp || (medicals || []).filter(m => m.id == record.id)[0].medical.physical.dbp" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                    <a-form-item label="血压" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }"
                                 :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                      {{ (medicals || []).filter(m => m.id == record.id)[0].medical.physical.sbp }}/{{ (medicals || []).filter(m => m.id == record.id)[0].medical.physical.dbp }}mmHg
                    </a-form-item>
                  </a-col>
                  <a-col v-if="(medicals || []).filter(m => m.id == record.id)[0].medical.physical.glu" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                    <a-form-item label="血糖" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }"
                                 :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                      {{ (medicals || []).filter(m => m.id == record.id)[0].medical.physical.glu }} mmol/L
                    </a-form-item>
                  </a-col>
                  <a-col v-if="(medicals || []).filter(m => m.id == record.id)[0].medical.physical.breath" :xxl="6" :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
                    <a-form-item label="呼吸" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }"
                                 :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                      {{ (medicals || []).filter(m => m.id == record.id)[0].medical.physical.breath }} 次/分钟
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="((medicals||[]).filter(m => m.id == record.id)[0].medical.pastHistory||'') != ''">
            <a-col>
              <a-form-item label="既往史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].medical.pastHistory }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="((medicals||[]).filter(m => m.id == record.id)[0].medical.selfHistory||'') != ''">
            <a-col>
              <a-form-item label="个人史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].medical.selfHistory }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="((medicals||[]).filter(m => m.id == record.id)[0].medical.familyHistory||'') != ''">
            <a-col>
              <a-form-item label="家族史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].medical.familyHistory }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="((medicals||[]).filter(m => m.id == record.id)[0].medical.otherHistory||'') != ''">
            <a-col>
              <a-form-item label="其它病史" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].medical.otherHistory }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="((medicals||[]).filter(m => m.id == record.id)[0].medical.symptom||'') != ''">
            <a-col>
              <a-form-item label="望闻问切" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                {{ (medicals || []).filter(m => m.id == record.id)[0].medical.symptom }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="((medicals||[]).filter(m => m.id == record.id)[0].pics||[]).length > 0">
            <a-col>
              <a-form-item label="症状图片" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                <img v-for="(item, index) in ((medicals||[]).filter(m => m.id == record.id)[0].pics||[])"
                     :src="item.url" :key="'img-'+(index+1)" class="img" @click="showFullImg(item.url)">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row
              v-if="((medicals||[]).filter(m => m.id == record.id)[0].annexes||[]).filter(m => m.type == 'CHECK_RESULT').length > 0">
            <a-col>
              <a-form-item label="检查结果" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                <img
                    v-for="(item, index) in ((medicals||[]).filter(m => m.id == record.id)[0].annexes||[]).filter(m => m.type == 'CHECK_RESULT')"
                    :src="item.pic.url" :key="'c-img-'+(index+1)" class="img" @click="showFullImg(item.pic.url)">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row
              v-if="((medicals||[]).filter(m => m.id == record.id)[0].annexes||[]).filter(m => m.type == 'INSPECT_RESULT').length > 0">
            <a-col>
              <a-form-item label="检验结果" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                <img
                    v-for="(item, index) in ((medicals||[]).filter(m => m.id == record.id)[0].annexes||[]).filter(m => m.type == 'INSPECT_RESULT')"
                    :src="item.pic.url" :key="'i-img-'+(index+1)" class="img" @click="showFullImg(item.pic.url)">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row
              v-if="((medicals||[]).filter(m => m.id == record.id)[0].annexes||[]).filter(m => m.type == 'MEDICAL').length > 0">
            <a-col>
              <a-form-item label="病历资料" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                <img
                    v-for="(item, index) in ((medicals||[]).filter(m => m.id == record.id)[0].annexes||[]).filter(m => m.type == 'MEDICAL')"
                    :src="item.pic.url" :key="'m-img-'+(index+1)" class="img" @click="showFullImg(item.pic.url)">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row
              v-if="((medicals||[]).filter(m => m.id == record.id)[0].annexes||[]).filter(m => m.type == 'PHYSICAL').length > 0">
            <a-col>
              <a-form-item label="体检报告" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                           :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                <img
                    v-for="(item, index) in ((medicals||[]).filter(m => m.id == record.id)[0].annexes||[]).filter(m => m.type == 'PHYSICAL')"
                    :src="item.pic.url" :key="'p-img-'+(index+1)" class="img" @click="showFullImg(item.pic.url)">
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>
        <a-collapse v-if="(((medicals||[]).filter(m => m.id == record.id).length > 0) && ((((medicals||[]).filter(m => m.id == record.id)[0].recipes||[]).length > 0) || (((medicals||[]).filter(m => m.id == record.id)[0].disposals||[]).length >0)))" :bordered="false"
                    :accordion="true" expand-icon-position="right"
                    style="margin-top: 10px;background:#fff;overflow-y: auto;">
          <a-collapse-panel v-for="item in (((medicals||[]).filter(m => m.id == record.id)[0].recipes||[]))" :key="item.code"
                            style="background: #ffffff;">
            <span slot="header" style="width: 100%;">
              <a-row style="line-height: 21px;">
                <a-col span="12" class="gpws-archive-model-title">
                  <img src="src/assets/img/split.png" style="margin-left:8px;margin-right: 9px;user-select: none;"/>{{ item.typeName }}
                </a-col>
                <a-col span="6" style="text-align: right;"><span style="color: #D02F2F;">{{ item.drugs.length }}</span> 项药品</a-col>
                <a-col span="6" style="text-align: right;">{{ ((item.type == 'CM' && item.doses > 0) ? ('付数:' + item.doses + '付') : ((item.type != 'CM' && item.days > 0) ? ('天数:' + item.days + '天') : '')) }}</a-col>
              </a-row>
            </span>
            <a-row v-if="item.type == 'CM'">
              <template v-for="(e, i) in item.drugs">
                <a-col span="8" :key="e.code" style="padding-left: 30px;line-height: 32px; height: 32px;">
                  {{ e.name }} &nbsp;{{ e.dosage }} &nbsp; {{ e.unit }}
                </a-col>
              </template>
            </a-row>
            <a-row v-else>
              <template v-for="(e, i) in item.drugs">
                <a-col :key="e.code" style="padding-left: 40px;line-height: 32px; height: 32px;">
                  {{ e.name }} &nbsp;&nbsp;{{ e.spec }} &nbsp;&nbsp;{{ e.form }} &nbsp;&nbsp; {{ e.dosage }}
                  &nbsp;{{ e.unit }}&nbsp;/&nbsp;{{ e.frequency }} &nbsp;&nbsp; {{ e.salesQty }} &nbsp;{{ e.salesUnit }}
                </a-col>
              </template>
            </a-row>
            <a-row>
              <a-col style="padding-left: 40px;line-height: 32px; height: 32px;">
                {{ item.usage }}
              </a-col>
            </a-row>
            <a-row>
              <a-col style="padding-left: 40px;line-height: 32px; height: 32px;">
                {{ item.advice }}
              </a-col>
            </a-row>
          </a-collapse-panel>
          <template v-if="(((medicals||[]).filter(m => m.id == record.id).length > 0) && (((medicals||[]).filter(m => m.id == record.id)[0].disposals||[]).length >0))">
            <a-collapse-panel :key="'d-p'+(medicals||[]).filter(m => m.id == record.id)[0].id" style="background: #ffffff;">
              <span slot="header">
                <a-row>
                  <a-col span="20" class="gpws-model-title">
                    <img src="../../assets/img/split.png" style="margin-left:8px;margin-right: 9px;user-select: none;"/>中医处置
                  </a-col>
                  <a-col span="4" style="text-align: right;"><span style="color: #D02F2F;">{{ ((medicals||[]).filter(m => m.id == record.id)[0].disposals||[]).length }}</span> 项</a-col>
                </a-row>
              </span>
              <a-row>
                <template v-for="(e, i) in ((medicals||[]).filter(m => m.id == record.id)[0].disposals||[])">
                  <a-col :key="e.code" style="padding-left: 40px;line-height: 32px; height: 32px;">
                    {{ e.disposeName }} &nbsp;&nbsp;{{e.quantity}}&nbsp;{{ e.unit }}&nbsp;&nbsp; {{ e.operator }} &nbsp;{{ e.describe }}
                  </a-col>
                </template>
              </a-row>
            </a-collapse-panel>
          </template>
        </a-collapse>
      </div>
    </a-table>
  </a-drawer>
</template>

<script>
import Vue from 'vue'
import hevueImgPreview from 'hevue-img-preview';
Vue.use(hevueImgPreview);
export default {
  name: "ArchiveDrawer",
  data() {
    return {
      visible: false,
      loading: false,
      loadTip: '正在查询患者档案信息....',
      current: {},
      medicals:[],
      grid: {
        id: '',
        type:'',
        organId:'',
        source:'',
        loading: false,
        columns: [{title: '序号', align: 'center', scopedSlots: {customRender: 'index'}, width: 60},
          {
            title: '就诊时间', dataIndex: 'recipeTime', key: 'recipeTime', align: 'center', width: 150,
            customRender: (text, record, index) => {
              return text == null || text == undefined || text == '' ? '-' : text;
            }
          },
          {
            title: '临床诊断', dataIndex: 'diagnostic', key: 'diagnostic',
            customRender: (text, record, index) => {
              return text == null || text == undefined || text == '' ? '-' : text;
            }
          },
          {
            title: '就诊类型', dataIndex: 'treatType', key: 'treatType',
            customRender: (text, record, index) => {
              return text == null || text == undefined || text == '' ? '-' : text;
            }
          },
          {
            title: '操作', dataIndex: 'operate', key: 'operate', align: 'center', width: 100,
            scopedSlots: {customRender: 'operate'}
          }],
        data: [],
        pagination: this.$pagination
      }
    }
  },
  mounted: function () {
    this.current = JSON.parse(localStorage.getItem("curruser"));
  },
  methods: {
    recipeAction:function (id){
      this.$emit('clickit', id);
      this.onDrawerClose();
    },
    showArchiveDrawer: function (id, type, organId, source) {
      this.grid.pagination.total = 0;
      this.grid.data = [];
      this.grid.id = id;
      this.grid.type = type;
      this.grid.organId = organId;
      this.grid.source = source;
      this.visible = true;
      this.searchAction();
    },
    searchAction: function () {
      Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
      let params = Object.assign({
        'entity.memberId': this.grid.id, 'entity.type':this.grid.type,
        'entity.organId': this.grid.organId, 'entity.statuses': ['RECIPE_WAIT_AUDIT', 'RECIPED',
          'RECIPE_PAID', 'FINISHED'].join(',')
      }, {start: 0, length: this.grid.pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 分页条操作
     */
    gridChangeAction: function (pagination, filters, sorter) {
      Object.assign(this.grid, {pagination: pagination});
      let params = Object.assign({
        'entity.memberId': this.grid.id, 'entity.type':this.grid.type,
        'entity.organId': this.grid.organId,
        'entity.statuses': ['RECIPE_WAIT_AUDIT', 'RECIPED',
          'RECIPE_PAID', 'FINISHED'].join(',')
      }, {start: (pagination.current - 1) * pagination.pageSize, length: pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 查询
     */
    loadGrid: function (params) {
      const self = this;
      self.grid.loading = true;
      self.$axios.get('/api/clinic/member/outpatients', {params: params}).then(function (res) {
        self.grid.loading = false;
        if (res.msg.flag == 0) {
          if (null == res.biz || res.biz.empty) {
            self.$message.info({content: res.msg.message, duration: 2});
            Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
          } else {
            Object.assign(self.grid, {
              data: res.biz.data,
              pagination: Object.assign(self.grid.pagination, {total: res.biz.count})
            });
          }
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function () {
        self.grid.loading = false;
      });
    },
    loadMedical:function(expanded, record){
      let medicals = (this.medicals||[]).filter(m => m.id == record.id);
      if(expanded && medicals.length <= 0){
        const self = this;
        self.grid.loading = true;
        self.$axios.get('/api/clinic/outpatient/'+record.id+'/medical').then(function(res){
          self.grid.loading = false;
          if(res.msg.flag == 0){
            self.medicals.push((res.biz||[]));
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        },function(){
          self.grid.loading = false;
        });
      }
    },
    showFullImg: function (url) {
      this.$hevueImgPreview({
        url: url,
        mainBackground: 'rgba(0, 0, 0, .5)', // 整体背景颜色
      });
    },
    onDrawerClose: function () {
      this.medicals = [];
      this.visible = false;
    }
  }
}
</script>

<style scoped>
.gpws-archive-model-title{
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  color: #000000;
}
.gpws-m-b-2{
  margin-bottom: 2px!important;
}
.img{
  width: 72px;
  height: 72px;
  border-radius:5px;
  border:#1890ff solid 1px;
  margin: 10px;
  cursor: pointer;
}
</style>